export default class YoutubePlayer {
  constructor(movieSelector = '.js-movie') {
    this.movies = document.querySelectorAll(movieSelector);
    this.scrollTimeouts = new WeakMap(); // 各 iframeに対応
    this.players = [];
    if (this.movies.length === 0) return;

    this.bindEvents();
  }

  // サムネイルをクリックで動画を生成
  bindEvents() {
    this.movies.forEach((element) => {
      element.addEventListener('click', () => this.handleClick(element));
    });
  }

  // 動画生成処理
  handleClick(element) {
    const youtubeId = element.getAttribute('data-video');
    const playerContainer = element.closest('.o-movie')?.querySelector('.js-player');

    if (!playerContainer || !youtubeId) {
      console.warn('プレイヤーが見つからないか、動画IDが未設定です。');
      return;
    }

    const player = new YT.Player(playerContainer, {
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
        rel: 0,
        playsinline: 1,
        // mute: 1,
      },
      videoId: youtubeId,
      events: {
        onReady: (event) => {
          const iframe = event.target.getIframe?.();
          if (iframe) {
            this.setupScrollControl(iframe);
          }
        }
      }
    });

    this.players.push(player);

    // サムネイルの親要素を非表示に
    const parent = element.parentElement;
    if (parent) {
      parent.style.display = 'none';
    }
  }

  // 全ての動画を一時停止
  pauseAll() {
    this.players.forEach(p => p.pauseVideo());
  }

  // スクロール中の pointer-eventsを制御（動画エリア内をスクロールした際のガクつき防止）
  setupScrollControl(iframe) {
    if (!iframe) return;
    if (iframe.dataset.scrollControlAttached === 'true') return;

    iframe.dataset.scrollControlAttached = 'true';

    const scrollHandler = () => {
      iframe.style.pointerEvents = 'none';

      clearTimeout(this.scrollTimeouts.get(iframe));
      const timeout = setTimeout(() => {
        iframe.style.pointerEvents = 'auto';
      }, 300);

      this.scrollTimeouts.set(iframe, timeout);
    };

    ['wheel', 'touchmove'].forEach((evt) =>
      window.addEventListener(evt, scrollHandler, { passive: true })
    );
  }
}
